import * as fs from "node:fs/promises";
import * as path from "node:path";
import { parse as parseYaml, stringify as stringifyYaml } from "yaml";

export interface CliConfig {
  gatewayUrl: string;
  gatewayClientId: string;
  gatewayTenantId: string;
  subscriptionId: string;
  containerAppResourceId: string;
  cachedAt: string;
}

function configDir(): string {
  const home = process.env.HOME ?? process.env.USERPROFILE ?? "";
  return path.join(home, ".m8t-stack");
}

export function getConfigPath(): string {
  return path.join(configDir(), "cli-config.yaml");
}

export async function readConfig(): Promise<CliConfig | null> {
  const configPath = getConfigPath();
  try {
    const raw = await fs.readFile(configPath, "utf8");
    let parsed: Partial<CliConfig> | null;
    try {
      parsed = parseYaml(raw) as Partial<CliConfig> | null;
    } catch {
      return null;
    }
    if (!parsed || typeof parsed !== "object") return null;
    if (
      typeof parsed.gatewayUrl !== "string" ||
      typeof parsed.gatewayClientId !== "string" ||
      typeof parsed.gatewayTenantId !== "string" ||
      typeof parsed.subscriptionId !== "string" ||
      typeof parsed.containerAppResourceId !== "string" ||
      typeof parsed.cachedAt !== "string"
    ) {
      return null;
    }
    return parsed as CliConfig;
  } catch (e) {
    if ((e as NodeJS.ErrnoException).code === "ENOENT") return null;
    throw e;
  }
}

export async function writeConfig(cfg: CliConfig): Promise<void> {
  const dir = configDir();
  const configPath = getConfigPath();
  await fs.mkdir(dir, { recursive: true });
  const yaml = stringifyYaml(cfg, { indent: 2 });
  const tmp = `${configPath}.tmp`;
  await fs.writeFile(tmp, yaml, "utf8");
  await fs.rename(tmp, configPath);
}

export async function resetConfig(): Promise<boolean> {
  const configPath = getConfigPath();
  try {
    await fs.unlink(configPath);
    return true;
  } catch (e) {
    if ((e as NodeJS.ErrnoException).code === "ENOENT") return false;
    throw e;
  }
}
